import React from 'react';

const formatDisplayDate = (date) => {
  if (!date) return '--/--/----';

  const sourceDate = new Date(date);

  if (Number.isNaN(sourceDate.getTime())) return '--/--/----';

  const day = String(sourceDate.getDate()).padStart(2, '0');
  const month = String(sourceDate.getMonth() + 1).padStart(2, '0');
  const year = sourceDate.getFullYear();

  return `${day}/${month}/${year}`;
};

const formatUserName = (user) => {
  if (!user) return '';

  return [user.firstName, user.lastName].filter(Boolean).join(' ') || '';
};

export default function DefaultSettingsTable({
  data,
  total,
  limit,
  offset,
  isLoading,
  onPageChange,
  onLimitChange,
}) {
  const currentPage = Math.floor(offset / limit) + 1;
  const totalPages = Math.max(1, Math.ceil((total || 0) / limit));

  return (
    <div className="default-settings-table">
      <div className="default-settings-table__toolbar">
        <div className="default-settings-table__meta">
          <span>{total || 0} cambios registrados</span>
        </div>

        <div className="default-settings-table__controls">
          <label htmlFor="history-limit">Ver</label>
          <select id="history-limit" value={limit} onChange={onLimitChange}>
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={15}>15</option>
          </select>
        </div>
      </div>

      <div className="default-settings-table__desktop">
        <table>
          <thead>
            <tr>
              <th style={{ textAlign: 'center' }}>Días de activación</th>
              <th style={{ textAlign: 'center' }}>Fecha solicitud</th>
              <th style={{ textAlign: 'center' }}>Fecha aplicación</th>
              <th style={{ textAlign: 'center' }}>Valor anterior</th>
              <th style={{ textAlign: 'center' }}>Modificado por</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="5" className="default-settings-table__empty">
                  Cargando historial...
                </td>
              </tr>
            ) : data?.length ? (
              data.map((row) => (
                <tr key={row._id}>
                  <td style={{ textAlign: 'center' }}>{row.activationDays ?? '--'}</td>
                  <td style={{ textAlign: 'center' }}>{formatDisplayDate(row.createdAt)}</td>
                  <td style={{ textAlign: 'center' }}>{formatDisplayDate(row.beginDate)}</td>
                  <td style={{ textAlign: 'center' }}>
                    <span className="default-settings-table__pill">
                      {row.previousActivationDays ?? 0} días
                    </span>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <div className="default-settings-table__user">
                      <span className="default-settings-table__user-dot" />
                      <span>{formatUserName(row.updatedBy)}</span>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="default-settings-table__empty">
                  No hay cambios programados.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="default-settings-table__mobile">
        {isLoading ? (
          <div className="default-settings-table__mobile-empty">Cargando historial...</div>
        ) : data?.length ? (
          data.map((row) => (
            <article className="default-settings-table__card" key={row._id}>
              <div className="default-settings-table__card-row">
                <span>Días de activación</span>
                <strong>{row.activationDays ?? '--'}</strong>
              </div>
              <div className="default-settings-table__card-row">
                <span>Fecha solicitud</span>
                <strong>{formatDisplayDate(row.createdAt)}</strong>
              </div>
              <div className="default-settings-table__card-row">
                <span>Fecha aplicación</span>
                <strong>{formatDisplayDate(row.beginDate)}</strong>
              </div>
              <div className="default-settings-table__card-row">
                <span>Valor anterior</span>
                <strong>{row.previousActivationDays ?? 0} días</strong>
              </div>
              <div className="default-settings-table__card-row">
                <span>Modificado por</span>
                <strong>{formatUserName(row.updatedBy)}</strong>
              </div>
            </article>
          ))
        ) : (
          <div className="default-settings-table__mobile-empty">No hay cambios programados.</div>
        )}
      </div>

      <div className="default-settings-table__pagination">
        <button
          type="button"
          onClick={(event) => onPageChange(event, currentPage - 1)}
          disabled={currentPage <= 1}
        >
          Anterior
        </button>
        <span>
          Página {currentPage} de {totalPages}
        </span>
        <button
          type="button"
          onClick={(event) => onPageChange(event, currentPage + 1)}
          disabled={currentPage >= totalPages}
        >
          Siguiente
        </button>
      </div>
    </div>
  );
}
